import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { IMilkingParlorNamesResponse } from 'models/MilkingProcess'
import MilkingProcessService from 'services/milkingProcessService'

export const useGetMilkingParlorNames = () => {
	const { data, refetch, isError, isLoading } = useQuery<
		IMilkingParlorNamesResponse,
		AxiosError
	>({
		queryKey: ['milking-parlor-names'],
		queryFn: async () => {
			const response = await MilkingProcessService.getMilkingParlorNames()
			return response
		},
		staleTime: 50000,
		retry: 3,
	})

	return {
		data,
		isLoading,
		isError,
		refetch,
	}
}
